<template>
    <div
        class="l-ss-c-filter-container"
        :class="{
            ['l-ss-c-filter-container-has-value']: !!hasValue,
            ['l-ss-c-filter-container-is-opened']: isOpen,
            ['l-ss-c-filter-container-is-short']: isShort,
            ['l-ss-c-filter-container-is-not-short']: !isShort,
            [`${idClassName}`]: true,
        }">
        <template v-if="shouldRenderContainer">
            <button
                v-if="$configuration.layout.filterPosition === 'top' || $screen.isMobile"
                :title="label"
                class="l-ss-c-filter-label l-ss-c-filter-container-label"
                @click="() => toggleOpen()">
                <span
                    class="l-ss-c-filter-container-label-counter"
                    v-if="showLabelCounter">
                    {{ value.options.length }}
                </span>
                {{ label | cut }}
                <i
                    class="l-ss-c-icon l-ss-c-filter-container-label-icon"
                    :style="{ transform: isOpen ? 'rotate(180deg)' : 'initial' }"
                    v-html="iconArrowDown"></i>
            </button>
            <h4
                class="l-ss-c-filter-title"
                v-if="positionLeft">
                {{ label }}
            </h4>
            <div
                v-show="isOpen || positionLeft"
                class="l-ss-c-filter-container-popup">
                <component
                    :is="resolveFilterComponent(filter.type)"
                    :is-short="isShort"
                    :show-title="false"
                    :type="filter.name"
                    v-bind="$props"
                    @change="params => $emit('change', params)"
                    @ready="() => toggleOpen(false)"
                    @close-filter="toggleOpen(false)"
                    :symbol="symbol"/>
            </div>
        </template>
        <template v-else>
            <component
                :is="resolveFilterComponent(filter.type)"
                :is-short="isShort"
                :show-title="false"
                v-bind="$props"
                @change="params => $emit('change', params)"
                @ready="() => toggleOpen(false)"
                :symbol="symbol"/>
        </template>
    </div>
</template>

<script>
    import { nanoid } from 'nanoid';
    import domPathContains from '../../helpers/dom-path-contains';
    import * as filters from './../common/filters/filter-types';
    import cutText from '../../helpers/cut-text';

    import iconArrowDown from '../../../core/assets/images/icons/arrow-down.svg';

    const LABEL_MAX_LENGTH = 30;

    export default {
        filters: {
            cut(value) {
                return cutText(value, LABEL_MAX_LENGTH);
            },
        },
        props: {
            filter: {
                type: Object,
                required: true,
            },
            value: {
                type: [Object, String],
                required: false,
            },
            isShort: {
                type: Boolean,
                default: false,
            },
            symbol: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                isOpen: false,
            };
        },
        computed: {
            positionLeft() {
                return this.$configuration.layout.filterPosition === 'left' && !this.$screen.isMobile;
            },
            idClassName() {
                return `l-ss-c-filter-${nanoid()}`;
            },
            shouldRenderContainer() {
                return ['m-toggle'].includes(this.filter.type) === false;
            },
            iconArrowDown() {
                return iconArrowDown;
            },
            hasValue() {
                return !!this.value;
            },
            label() {
                const label = this.$t(`filters.byType.${this.filter.name}`);
                const resultLabel = label ? (label.label || label.title) || this.filter.name : this.filter.name;
                const firstLetter = resultLabel.charAt(0);
                return firstLetter.toUpperCase() + resultLabel.slice(1);
            },
            showLabelCounter() {
                return Boolean(typeof this.value === 'object' && this.value.options instanceof Array && this.value.options.length > 0);
            },
        },
        created() {
            if (this.isShort) {
                const onBodyClick = (event) => {
                    let path = event.path || (event.composedPath && event.composedPath());
                    if (domPathContains(path, `.${this.idClassName}`) === false) {
                        this.isOpen = false;
                    }
                };
                this.onBodyClick = onBodyClick;
                document.body.addEventListener('click', onBodyClick);
            }
        },

        beforeDestroy() {
            if (this.onBodyClick) {
                document.body.removeEventListener('click', this.onBodyClick);
            }
        },
        methods: {
            resolveFilterComponent(type) {
                return filters.resolveFilterComponent(type);
            },
            toggleOpen(value) {
                this.isOpen = value === undefined
                    ? !this.isOpen
                    : value;
            },
        },
    };
</script>
